import React, { lazy, Suspense, useEffect, useState } from 'react';
import { Bot } from 'lucide-react';

const VapiVoiceAssistantPanel = lazy(() => import('./VapiVoiceAssistantPanel'));

const VapiVoiceAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setIsOpen(true);
    window.addEventListener('open-vapi-voice-assistant', onOpen);
    return () => window.removeEventListener('open-vapi-voice-assistant', onOpen);
  }, []);

  return (
    <div className="floating-voice-widget" aria-live="polite">
      {isOpen ? (
        <Suspense fallback={null}>
          <VapiVoiceAssistantPanel onClose={() => setIsOpen(false)} />
        </Suspense>
      ) : null}

      <button
        type="button"
        className="floating-voice-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={isOpen ? 'Close voice assistant' : 'Open voice assistant'}
        aria-expanded={isOpen}
      >
        <Bot size={22} />
      </button>
    </div>
  );
};

export default VapiVoiceAssistant;